import { formatMoney } from '../../../../shared/format/public-api';

export function formatTicketVsBranch(operatorTicket: number, branchTicket: number): string {
  const op = formatMoney(Math.round(operatorTicket));
  if (branchTicket <= 0) return op;
  const branch = `${formatMoney(Math.round(branchTicket))} sucursal`;
  const ratio = operatorTicket / branchTicket;
  const pct = ((ratio - 1) * 100).toFixed(0);
  const sign = ratio >= 1 ? '+' : '';
  return `${op} (${sign}${pct}% vs ${branch})`;
}

export function formatTicketVs30d(ticket: number, avg30d: number, pct: number | null): string | null {
  if (avg30d <= 0) return null;
  const base = formatMoney(Math.round(ticket));
  if (pct == null) return `vs promedio 30 días: ${formatMoney(Math.round(avg30d))}`;
  const sign = pct >= 0 ? '+' : '';
  return `${base} (${sign}${(pct * 100).toFixed(0)}% vs tu promedio de 30 días)`;
}

export function formatPct(value: number): string {
  return `${(value * 100).toFixed(1)}%`;
}
